// src/pages/Private/Teacher/QuizManagement/QuizResults.js
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getQuizResults, getQuizById } from '../../../../api/teacherApi'; // getQuizById import edildi
import './QuizResults.css';

function QuizResults() {
  const { quizId } = useParams();
  const navigate = useNavigate();
  const [quiz, setQuiz] = useState(null);
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({
    totalAttempts: 0,
    averageScore: 0,
    passRate: 0,
    highestScore: 0,
    lowestScore: 0
  });

  useEffect(() => {
    loadResults();
  }, [quizId]);

  const loadResults = async () => {
    try {
      const [quizData, resultsData] = await Promise.all([
        getQuizById(quizId), // Burada getQuizById kullanılıyor
        getQuizResults(quizId)
      ]);
      setQuiz(quizData);
      setResults(resultsData);
      calculateStats(resultsData);
    } catch (error) {
      console.error('Sonuçlar yüklenirken hata:', error);
    } finally {
      setLoading(false);
    }
  };

  const calculateStats = (resultsData) => {
    if (resultsData.length === 0) return;

    const scores = resultsData.map(r => r.score || 0);
    const total = scores.length;
    const sum = scores.reduce((a, b) => a + b, 0);
    const passed = resultsData.filter(r => r.passed).length;

    setStats({
      totalAttempts: total,
      averageScore: Math.round(sum / total),
      passRate: Math.round((passed / total) * 100),
      highestScore: Math.max(...scores),
      lowestScore: Math.min(...scores)
    });
  };

  const exportResults = () => {
    const csv = [
      ['Öğrenci', 'Email', 'Puan', 'Durum', 'Süre', 'Tarih'].join(','),
      ...results.map(r => [
        r.student?.name || 'Bilinmiyor',
        r.student?.email || '',
        r.score || 0,
        r.passed ? 'Geçti' : 'Kaldı',
        Math.round(r.timeSpent / 60) + ' dk',
        new Date(r.completedAt).toLocaleDateString('tr-TR')
      ].join(','))
    ].join('\n');

    const blob = new Blob([csv], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `quiz-sonuclari-${quizId}.csv`;
    a.click();
  };

  if (loading) return <div className="loading">Yükleniyor...</div>;

  return (
    <div className="quiz-results">
      <div className="results-header">
        <div>
          <h1>{quiz?.title} - Sonuçlar</h1>
          <p>Toplam {results.length} öğrenci katıldı</p>
        </div>
        <div className="header-actions">
          <button onClick={exportResults} className="export-btn">
            📥 CSV İndir
          </button>
          <button onClick={() => navigate(-1)} className="back-btn">
            ← Geri
          </button>
        </div>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <span className="stat-value">{stats.totalAttempts}</span>
          <span className="stat-label">Toplam Katılım</span>
        </div>
        <div className="stat-card">
          <span className="stat-value">%{stats.averageScore}</span>
          <span className="stat-label">Ortalama Puan</span>
        </div>
        <div className="stat-card">
          <span className="stat-value">%{stats.passRate}</span>
          <span className="stat-label">Başarı Oranı</span>
        </div>
        <div className="stat-card">
          <span className="stat-value">%{stats.highestScore}</span>
          <span className="stat-label">En Yüksek</span>
        </div>
      </div>

      <div className="results-list">
        <h2>Öğrenci Cevapları</h2>
        {results.length === 0 ? (
          <div className="empty-state">
            <p>Henüz kimse quizi çözmemiş.</p>
          </div>
        ) : (
          results.map(result => (
            <div key={result._id} className="result-card">
              <div className="result-header">
                <div className="student-info">
                  <h3>{result.student?.name || 'İsimsiz Öğrenci'}</h3>
                  <span className="student-email">{result.student?.email}</span>
                </div>
                <div className="result-score">
                  <span className={`score-badge ${result.passed ? 'passed' : 'failed'}`}>
                    %{result.score}
                  </span>
                  <span className="result-date">
                    {new Date(result.completedAt).toLocaleDateString('tr-TR')}
                  </span>
                </div>
              </div>

              <div className="result-details">
                <div className="detail-item">
                  <span className="detail-label">Doğru:</span>
                  <span className="detail-value correct">
                    {result.answers?.filter(a => a.isCorrect).length || 0}
                  </span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Yanlış:</span>
                  <span className="detail-value incorrect">
                    {result.answers?.filter(a => !a.isCorrect).length || 0}
                  </span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Süre:</span>
                  <span className="detail-value">
                    {Math.round(result.timeSpent / 60)} dk
                  </span>
                </div>
              </div>

              <button className="view-details-btn">
                Detayları Gör
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default QuizResults;